import reducer from './reducer';
import saga from './saga';
import { reduxInitialized } from './actions';
export function getDiscordModule() {
    return {
        id: 'discordModule',
        reducerMap: reducer,
        initialActions: [
            reduxInitialized()
        ],
        sagas: [
            saga
        ]
    };
}

//# sourceMappingURL=module.js.map